export default __webpack_public_path__ + "static/media/Mobile-07.f820a73c.jpg";